import React from "react";
import {useAppSelector} from "../../utils/store/store";
import {getUser} from "../../utils/store/userSlice";
import {Utils} from "../../utils/Utils";
import Home from "./home/Home";
import SendMessage from "./messaging/SendMessage";
import Administrators from "./users/admins/Administrators";
import Members from "./users/members/Members";
import MembershipTypes from "./users/memberships/MembershipTypes";
import MemberRegions from "./users/regions/MemberRegions";

type page = 'home' | 'members' | 'administrators' | 'membership_types' | 'member_regions' | 'email_members' | 'sms_members'
export default function Dashboard() {
    const user = useAppSelector(getUser)
    const [page, setPage] = React.useState<page>('home')

    const logOut = () => {

    }

    return (
        <>
            <aside className="sidebar">
                <div className="sidebar-header">
                    <img src={Utils.IMG_LOGO} alt="logo"/>
                    <h2>UHOA</h2>
                </div>

                <ul className="sidebar-links">
                    <li>
                        <span className={`sidebar_link ${page === 'home' ? 'active' : ''}`} onClick={() => setPage('home')}>
                            <span className="material-symbols-outlined"> dashboard </span>
                            <span className={'title'}>Dashboard</span>
                        </span>
                    </li>

                    <h4>
                        <span>User Management</span>
                        <div className="menu-separator"></div>
                    </h4>
                    <li>
                        <span className={`sidebar_link ${page === 'administrators' ? 'active' : ''}`}
                              onClick={() => setPage('administrators')}>
                            <span className="material-symbols-outlined">folder</span>
                            <span className={'title'}>Administrators</span>
                        </span>
                    </li>

                    <li>
                        <span className={`sidebar_link ${page === 'members' ? 'active' : ''}`}
                              onClick={() => setPage('members')}>
                            <span className="material-symbols-outlined"> groups </span>
                            <span className={'title'}>Members</span>
                        </span>
                    </li>

                    <li>
                        <span className={`sidebar_link ${page === 'membership_types' ? 'active' : ''}`}
                              onClick={() => setPage('membership_types')}>
                            <span className="material-symbols-outlined"> groups </span>
                            <span className={'title'}>Membership Types</span>
                        </span>
                    </li>

                    <li>
                        <span className={`sidebar_link ${page === 'member_regions' ? 'active' : ''}`}
                              onClick={() => setPage('member_regions')}>
                            <span className="material-symbols-outlined"> groups </span>
                            <span className={'title'}>Member Regions</span>
                        </span>
                    </li>

                    <h4>
                        <span>Messaging</span>
                        <div className="menu-separator"></div>
                    </h4>
                    <li>
                        <span className={`sidebar_link ${page === 'sms_members' ? 'active' : ''}`}
                              onClick={() => setPage('sms_members')}>
                            <span className="material-symbols-outlined">sms</span> 
                            <span className={'title'}>Send SMS</span>
                        </span>
                    </li>
                    <li>
                        <span className={`sidebar_link ${page === 'email_members' ? 'active' : ''}`}
                              onClick={() => setPage('email_members')}>
                            <span className="material-symbols-outlined">mail</span> 
                            <span className={'title'}>Send Email</span>
                        </span>
                    </li>

                    <h4>
                        <span>Account</span>
                        <div className="menu-separator"></div>
                    </h4>
                    <li>
                        <span className={'sidebar_link'}>
                            <span className="material-symbols-outlined">account_circle</span> 
                            <span className={'title'}>Change Password</span>
                        </span>
                    </li>
                    <li>
                        <span className={'sidebar_link'} onClick={logOut}>
                            <span className="material-symbols-outlined">logout</span> 
                            <span className={'title'}>Logout</span>
                        </span>
                    </li>
                </ul>


                <div className="user-account">
                    <div className="user-profile">
                        <img src={Utils.resources.avatar} alt="Profile Image"/>
                        <div className="user-detail">
                            <h3>{`${user.lastName} ${user.firstName}`}</h3>
                            <span>Administrator</span>
                        </div>
                    </div>
                </div>
            </aside>

            <div className={'side_content'}>
                {page === 'home' && <Home/>}

                {page === 'administrators' && <Administrators/>}
                {page === 'members' && <Members/>}
                {page === 'membership_types' && <MembershipTypes/>}
                {page === 'member_regions' && <MemberRegions/>}

                {page === 'sms_members' && <SendMessage type={'SMS'}/>}
                {page === 'email_members' && <SendMessage type={'Email'}/>}
            </div>
        </>
    )
}